import { Component, EventEmitter, Input, Output } from "@angular/core"
import { Roster } from "../../../../models/roster.model"
import { ModalRef } from "../../../modal/modal-ref"
import { AssignModalType } from "../assign-modal.component"

@Component({
    selector: "app-select-class-view",
    templateUrl: "./select-class-view.component.html",
    styleUrls: ["./select-class-view.component.scss"],
})
export class SelectClassViewComponent {
    @Input() public rosters: Roster[] = []
    @Input() public type: AssignModalType = AssignModalType.any
    @Input() public activeModal: ModalRef = null
    @Output() public step = new EventEmitter<number>()

    public googleClassImg: string = ""
    public assignType = AssignModalType

    public constructor() {
        this.googleClassImg = require("../../../../../assets/classroom-color-round.png").default
    }

    public checkIfSelected() {
        if (this.rosters) {
            return !!this.rosters.find((roster: Roster) => roster.selected)
        }
        return false
    }

    public next() {
        this.step.emit(2)
    }
}
